import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchByIdFactory } from "./fetchByIdFactory";
import { GET_SECTION_INFO, SectionResponse, Section} from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall";

export const fetchSectionsBySystemIdsThunk =  createAsyncThunk(
  `sections/fetchBySystemIds`,
  fetchByIdFactory<SectionResponse, Section>(GET_SECTION_INFO, (section) => section.data.section.info)
) satisfies AsyncThunk<Section[], number[], AsyncThunkConfig> as AsyncThunk<Section[], number[], AsyncThunkConfig>